// extracted by mini-css-extract-plugin
export default {"bgSite":"EditarCadastro_bgSite__Dwnao"};